import {
  Box,
  Typography,
  TextField,
  Card,
  CardContent,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  MenuItem,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ChevronLeft, Pets } from '@mui/icons-material';
import TaxExemptBadge from 'src/components/TaxExemptBadge';
import { Form, FormikProvider, useFormik } from 'formik';
import Page from 'src/components/Page';
import { donations, foodRun } from 'src/backend';
import { useParams } from 'react-router';
import { useEffect, useState, useMemo } from 'react';
import useAuth from 'src/hooks/useAuth';
import moment from 'moment-timezone';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { Sync } from '@mui/icons-material';
import _toLower from 'lodash/toLower';
import _capitalize from 'lodash/capitalize';
import _indexOf from 'lodash/indexOf';
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _isFinite from 'lodash/isFinite';
import { parseJsonArray } from 'src/utils/json';
import {
  useAddFoodRunSchema,
  useEditRecurringDonationSchema,
} from '../schedule/FoodRun/helper';
import { getScheduleEndDate } from 'src/utils/recurring';
import DonationScheduleEnd from 'src/components/DonationScheduleEnd';
import {
  constructUTCTimes,
  offsetForDST,
  Distance,
  toDonationInventoryPayload,
} from 'careit';
import {
  CheckboxFormComponent,
  SelectAddressComponentPopup,
  DateComponent,
  TimeComponent,
  buildDonationWriteFields,
  UploadImagesComponent,
  DayOfTheMonthSelector,
  AutoCompleteComponent,
} from 'src/hooks/useForm';
import { Weight } from 'careit';
import { useMeasureFieldUnits } from 'src/components/MeasureField';
import useEditRecurringDonations from 'src/hooks/useEditRecurringDonations';
import { v4 as uuidv4 } from 'uuid';
import { uploadImages } from 'src/components/form/UploadImages';
import LoadingScreen from 'src/components/LoadingScreen';
import useVehicles from 'src/hooks/useVehicles';
import useDriverAvailability from 'src/hooks/useDriverAvailability';
import _isNumber from 'lodash/isNumber';
import getTimeZoneIdFromCoords from 'src/utils/getTimeZoneIdFromCoords';
import { useTranslation } from 'react-i18next';
import { useGetVehicleLabels } from 'src/constants';
import DriverSelector from 'src/components/MultipleDriversSelector';
import useGetPartialRescues from 'src/hooks/useGetRescuesByDonationId';
import useGetPatternDestinationAddresses from 'src/hooks/useGetPatternDestinationAddresses';
import DonationFoodTypesSelector, {
  handlePartialAddressChange,
  useFoodTypesSelector,
} from 'src/components/DonationFoodTypesSelector';
import EditDonationInventoryPicker from 'src/components/EditDonationInventoryPicker';
import {
  syncFoodTypesWithInventory,
  toggleInventoryItem,
} from 'src/hooks/donationFormHelpers';
import { buildFoodRunRecipientMatchRequest } from 'src/utils/foodRunRecipientMatching';
import { getFoodRunRecipientAutocompleteProps } from 'src/components/RecipientMatchDisplay';
import parseErrorObject from 'src/utils/parseErrorObject';

const DAYS_OF_THE_WEEK = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

const processDaysOfTheWeek = (values) => {
  return _map(values, (value) => _indexOf(DAYS_OF_THE_WEEK, value));
};

const EditRecurringPatternForm = () => {
  const { t } = useTranslation('translation');
  const vehicleLabelsWithUnit = useGetVehicleLabels();
  const { defaultDistanceUnit: distanceUnit, defaultWeightUnit } =
    useMeasureFieldUnits();
  const foodTypeIds = useFoodTypesSelector().map(({ id }) => id);
  const AddFoodRunSchema = useAddFoodRunSchema();
  const EditRecurringDonationSchema = useEditRecurringDonationSchema();
  const { id } = useParams();
  const { data: patternPatialRescues = [] } = useGetPartialRescues(id, {
    enabled: !!id,
    type: 'pattern',
  });
  const history = useHistory();
  const [defaultStartTime, setDefaultStartTime] = useState(new Date());
  const [defaultEndTime, setDefaultEndTime] = useState(new Date());
  const [defaultStartDate, setDefaultStartDate] = useState(moment());
  const [defaultEndDate, setDefaultEndDate] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [recurringPatternData, setRecurringPatternData] = useState({});
  const { user, plan, isFoodMover } = useAuth();
  const { checkAvailabilityForDrivers, drivers } = useDriverAvailability();
  const [showExistingInstanceWarning, setShowExistingInstanceWarning] =
    useState(false);
  const [fetchingPatternData, setFetchingPatternData] = useState(true);
  const [deleteExtraInstances, setDeleteExtraInstances] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [additionalImages, setAdditionalImages] = useState([]);
  const defaultDaysofTheWeek = recurringPatternData.days_of_the_week
    ? parseJsonArray(recurringPatternData.days_of_the_week).map(
        (day) => DAYS_OF_THE_WEEK[day]
      )
    : [];
  const [donors, setDonors] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const { vehicles } = useVehicles();
  const recipientStatusByTeamId = useMemo(
    () =>
      recipients.reduce((acc, recipient) => {
        if (recipient?.team_id && recipient?.onboarding) {
          acc[recipient.team_id] = recipient.onboarding;
        }
        return acc;
      }, {}),
    [recipients]
  );

  const { data: patternDestinationAddresses = [] } =
    useGetPatternDestinationAddresses(id);

  const isFoodRun = useMemo(
    () => recurringPatternData.is_food_run,
    [recurringPatternData]
  );
  const savedInventoryItems = useMemo(
    () => recurringPatternData.inventory_items ?? [],
    [recurringPatternData.inventory_items]
  );

  useEffect(() => {
    if (!isFoodRun) return;
    const moverTeamId =
      recurringPatternData.food_mover_team_id ??
      recurringPatternData.created_by_team_id;
    if (moverTeamId && moverTeamId !== user.team_id) {
      history.replace(PATH_DASHBOARD.root);
    }
  }, [isFoodRun, recurringPatternData, user.team_id, history]);

  const defaultVehicleSize = String(
    _indexOf(['CAR', 'VAN', 'TRUCK'], recurringPatternData.vehicle_name)
  );

  const defaultDeliveryOption = String(
    _indexOf(
      ['SELF-DELIVER', 'RECEIVER-PICKUP', 'DELIVERY-BY-FOOD-MOVER'],
      recurringPatternData.delivery_option
    )
  );

  const foodWeightArr = parseJsonArray(recurringPatternData.food_weight);
  const foodWeightObj = foodWeightArr.reduce(
    (foodWeights, foodType) => ({
      ...foodWeights,
      [_toLower(foodType.food_type)]: {
        value: new Weight(foodType.estimated_weight ?? 0, 'lbs').asRounded(
          foodType.estimated_weight_unit
        ),
        unit: foodType.estimated_weight_unit,
        ...(recurringPatternData?.is_partial
          ? {
              assignedRecipients: patternPatialRescues
                .filter(
                  (r) => _toLower(r.food_type) === _toLower(foodType.food_type)
                )
                .map((rescue) => ({
                  patternRescueId: rescue.id,
                  teamId: rescue.recipient_team_id ?? 'unassigned',
                  reservedWeight: new Weight(
                    rescue.partial_weight_reserved ?? 0,
                    'lbs'
                  ).asRounded(foodType.estimated_weight_unit),
                })),
              minReservableWeight: new Weight(
                foodType.min_reservable_weight ?? 0,
                'lbs'
              ).asRounded(foodType.estimated_weight_unit),
              maxReservableWeight: new Weight(
                foodType.max_reservable_weight ?? 0,
                'lbs'
              ).asRounded(foodType.estimated_weight_unit),
            }
          : {}),
      },
    }),
    {}
  );

  useEffect(() => {
    if (user.timezone_id && recurringPatternData.start_time) {
      const startDateStartTimeNoOffset = moment.utc(
        `${recurringPatternData.start_date} ${recurringPatternData.start_time}`,
        'YYYY-MM-DD HH:mm:ss'
      );
      const startDateEndTimeNoOffset = moment.utc(
        `${recurringPatternData.start_date} ${recurringPatternData.end_time}`,
        'YYYY-MM-DD HH:mm:ss'
      );

      const { start: startDateStartTimeInUTC, end: startDateEndTimeInUTC } =
        offsetForDST(
          startDateStartTimeNoOffset.clone(),
          startDateEndTimeNoOffset.clone(),
          recurringPatternData.timezone_id,
          recurringPatternData.utc_inserted_on_dst
        );

      let endDateStartTimeInUserTz = null;
      if (recurringPatternData.end_date) {
        const endDateStartTimeNoOffset = moment.utc(
          `${recurringPatternData.end_date} ${recurringPatternData.start_time}`,
          'YYYY-MM-DD HH:mm:ss'
        );
        const endDateEndTimeNoOffset = moment.utc(
          `${recurringPatternData.end_date} ${recurringPatternData.end_time}`,
          'YYYY-MM-DD HH:mm:ss'
        );

        const { start: endDateStartTimeInUTC } = offsetForDST(
          endDateStartTimeNoOffset.clone(),
          endDateEndTimeNoOffset.clone(),
          recurringPatternData.timezone_id,
          recurringPatternData.utc_inserted_on_dst
        );
        endDateStartTimeInUserTz = moment
          .utc(endDateStartTimeInUTC)
          .tz(recurringPatternData.timezone_id);
      }

      const startDateStartTimeInUserTz = moment
        .utc(startDateStartTimeInUTC)
        .tz(recurringPatternData.timezone_id);
      const startDateEndTimeInUserTz = moment
        .utc(startDateEndTimeInUTC)
        .tz(recurringPatternData.timezone_id);

      const startTime = moment()
        .hours(startDateStartTimeInUserTz.hours())
        .minutes(startDateStartTimeInUserTz.minutes())
        .seconds(0)
        .toDate();
      const endTime = moment()
        .hours(startDateEndTimeInUserTz.hours())
        .minutes(startDateEndTimeInUserTz.minutes())
        .seconds(0)
        .toDate();
      setDefaultStartTime(startTime);
      setDefaultEndTime(endTime);
      setDefaultStartDate(startDateStartTimeInUserTz);
      setDefaultEndDate(endDateStartTimeInUserTz);
    }
  }, [recurringPatternData, user.timezone_id]);

  const defaultDayOfTheMonth = useMemo(() => {
    if (
      recurringPatternData.day_of_the_month &&
      recurringPatternData.timezone_id
    ) {
      return {
        isLastDay: false,
        customDay: recurringPatternData.day_of_the_month,
      };
    } else if (recurringPatternData.is_last_day_of_the_month) {
      return {
        isLastDay: true,
        customDay: null,
      };
    } else if (
      _isFinite(recurringPatternData.no_of_the_week_in_month) &&
      _isFinite(recurringPatternData.day_of_the_week_in_month)
    ) {
      return {
        isLastDay: false,
        customDay: null,
        week: {
          number: recurringPatternData.no_of_the_week_in_month,
          dayOfTheWeek: recurringPatternData.day_of_the_week_in_month,
        },
      };
    } else {
      return {
        isLastDay: false,
        customDay: null,
      };
    }
  }, [
    recurringPatternData.day_of_the_month,
    recurringPatternData.is_first_day_of_the_month,
    recurringPatternData.is_last_of_the_month,
    recurringPatternData.timezone_id,
  ]);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      drivers:
        recurringPatternData.is_food_run ||
        recurringPatternData.delivery_option === 'SELF-DELIVER'
          ? recurringPatternData.pattern_rescue_drivers
          : [],
      destinationAddresses: recurringPatternData.is_partial
        ? patternDestinationAddresses.map((address) => {
            return {
              teamId: address.recipient_team_id,
              location: {
                lat: address.lat,
                lng: address.lng,
                formattedAddress: address.formatted_address,
                place: address.place,
                streetAddress: address.street_address,
                city: address.city,
                province: address.province,
                country: address.country,
                zipCode: address.zip_code,
                placeId: address.place_id,
              },
            };
          })
        : [],
      isPartialRescue: recurringPatternData.is_partial,
      isFoodRun: recurringPatternData.is_food_run,
      title: recurringPatternData.title || '',
      description: recurringPatternData.description || '',
      foodTypes: foodWeightObj,
      occurrenceType: recurringPatternData.is_recurring
        ? recurringPatternData.end_date
          ? 'recurring'
          : 'indefinite'
        : 'onetime',
      interval: _capitalize(recurringPatternData.recurring_type),
      startDate: defaultStartDate.format('MM/DD/YYYY'),
      endDate: defaultEndDate && defaultEndDate.format('MM/DD/YYYY'),
      daysOfTheWeek: defaultDaysofTheWeek,
      dayOfTheMonth: defaultDayOfTheMonth,
      startTime: defaultStartTime,
      endTime: defaultEndTime,
      donor: recurringPatternData.donor_team_id || '',
      receiver: recurringPatternData.receiver_team_id || '',
      driver: recurringPatternData.food_runner_id || '',
      available_on_unassign: Boolean(
        Number(recurringPatternData.available_on_unassign)
      ),
      pickupInstructions: recurringPatternData.pickup_instructions || '',
      dropoffInstructions: recurringPatternData.dropoff_instructions || '',
      vehicleSize: defaultVehicleSize,
      deliveryOption: defaultDeliveryOption,
      pickup_address: {
        lat: recurringPatternData.pickup_lat,
        lng: recurringPatternData.pickup_lng,
        formattedAddress: recurringPatternData.pickup_formatted_address,
        place: recurringPatternData.pickup_place,
        streetAddress: recurringPatternData.pickup_street_address,
        city: recurringPatternData.pickup_city,
        province: recurringPatternData.pickup_province,
        country: recurringPatternData.pickup_country,
        zipCode: recurringPatternData.pickup_zip_code,
        placeId: recurringPatternData.pickup_place_id,
        timeZoneId: recurringPatternData.pickup_timezone_id,
      },
      dest_address: !recurringPatternData.is_partial
        ? {
            lat: patternDestinationAddresses[0]?.lat,
            lng: patternDestinationAddresses[0]?.lng,
            formattedAddress: patternDestinationAddresses[0]?.formatted_address,
            place: patternDestinationAddresses[0]?.place,
            streetAddress: patternDestinationAddresses[0]?.street_address,
            city: patternDestinationAddresses[0]?.city,
            province: patternDestinationAddresses[0]?.province,
            country: patternDestinationAddresses[0]?.country,
            zipCode: patternDestinationAddresses[0]?.zip_code,
            placeId: patternDestinationAddresses[0]?.place_id,
            timeZoneId: patternDestinationAddresses[0]?.timezone_id,
          }
        : {},
      custom_addresses: Boolean(
        recurringPatternData.pickup_lat || recurringPatternData.dest_lat
      ),
      images: [],
      selectedInventoryItems: savedInventoryItems,
      inventoryFoodTypes: foodWeightObj,
      deliveryRadius: recurringPatternData.delivery_radius
        ? new Distance(recurringPatternData.delivery_radius, 'mi').asRounded(
            distanceUnit.value
          )
        : null,
      estimatedRescueTimeMinutes:
        recurringPatternData.estimated_rescue_time_minutes > 0
          ? recurringPatternData.estimated_rescue_time_minutes
          : 30,
    },
    validationSchema: recurringPatternData.is_food_run
      ? AddFoodRunSchema(donors, recipients, {
          recipientStatusByTeamId,
          existingDonorTeamId: recurringPatternData.donor_team_id,
        })
      : EditRecurringDonationSchema(donors, recipients, {
          recipientStatusByTeamId,
        }),
    onSubmit: async (data) => {
      setLoading(true);
      try {
        const isRecurring = ['recurring', 'indefinite'].includes(
          data.occurrenceType
        );
        let pickupTimeZoneId = null;
        if (_isNumber(data?.pickup_address?.lat)) {
          pickupTimeZoneId = await getTimeZoneIdFromCoords(
            data?.pickup_address
          );
        }
        let destTimeZoneId = null;
        if (_isNumber(data?.dest_address?.lat)) {
          destTimeZoneId = await getTimeZoneIdFromCoords(data?.dest_address);
        }

        const timeZoneId =
          pickupTimeZoneId ?? recurringPatternData?.timezone_id;
        const { startDate, startTime, endDate, endTime } = constructUTCTimes({
          ...data,
          timezone_id: timeZoneId,
          isRecurring,
        });

        //Check if the start date falls on DST
        const isDST = moment.tz(data.startDate, timeZoneId).hours(11).isDST();

        if (!data.isFoodRun && data.deliveryOption === '1') {
          data.driver = null;
        }

        const imageUrls = await uploadImages({
          images,
          folder: `recurring-pattern/${recurringPatternData.id}`,
          source: 'edit-recurring-donations',
        });
        const additionalUrls = await uploadImages({
          images: additionalImages,
          folder: `recurring-pattern/${recurringPatternData.id}`,
          source: 'edit-recurring-donations-additional',
        });

        const donationData = {
          drivers:
            data.isFoodRun || Number(data.deliveryOption) === 0
              ? data.drivers
              : [],
          vehicleSize: Number(data.vehicleSize),
          deliveryOption: Number(data.deliveryOption),
          startDate,
          endDate: data.occurrenceType === 'indefinite' ? null : endDate,
          dayOfTheMonth: data.dayOfTheMonth,
          title: data.title?.trim() ? data.title : null,
          description: data.description,
          daysOfTheWeek: processDaysOfTheWeek(data.daysOfTheWeek),
          interval: data.interval,
          donorTeam: data.donor,
          foodMoverTeam: recurringPatternData.food_mover_team_id,
          availableOnUnassign: data.available_on_unassign,
          pickupInstructions: data.pickupInstructions,
          dropoffInstructions: data.dropoffInstructions,
          notifyOnEdit: data.notifyOnEdit,
          startTime,
          endTime,
          isRecurring,
          id: recurringPatternData.id,
          deleteExtraInstances,
          timezone_id: timeZoneId,
          isDST,
          pickup_address: data.custom_addresses
            ? {
                ...data.pickup_address,
                timeZoneId,
                place: data.pickup_address?.name,
              }
            : {},
          ...buildDonationWriteFields({
            foodTypes: data.foodTypes,
            isPartialRescue:
              !recurringPatternData.is_food_run && data.isPartialRescue,
            receiverTeamId:
              data.receiver && data.receiver !== 'unassigned'
                ? data.receiver
                : null,
            destAddress: data.custom_addresses
              ? {
                  ...data.dest_address,
                  timeZoneId: destTimeZoneId,
                  place: data.dest_address?.name,
                }
              : null,
            destinationAddresses: data.isPartialRescue
              ? data.destinationAddresses
              : [],
          }),
          isFoodRun: recurringPatternData.is_food_run,
          images: imageUrls,
          ...(recurringPatternData.is_food_run
            ? {}
            : {
                inventoryItems: toDonationInventoryPayload(
                  data.selectedInventoryItems
                ),
              }),
          deliveryRadius: data.deliveryRadius
            ? new Distance(Number(data.deliveryRadius), distanceUnit.value).as(
                'mi'
              )
            : null,
          estimatedRescueTimeMinutes:
            user.rescue_time_tracking_enabled &&
            (data.isFoodRun || data.deliveryOption === '0')
              ? data.estimatedRescueTimeMinutes
              : null,
        };

        const service = recurringPatternData.is_food_run
          ? foodRun.update
          : donations.update;
        service(donationData)
          .then(async () => {
            if ((additionalUrls || []).length > 0) {
              await donations.createDonationImages({
                isRecurring: true,
                donationId: null,
                images: additionalUrls,
                isAdditional: true,
                patternId: recurringPatternData.id,
              });
            }
          })
          .then(() => {
            setLoading(false);
            enqueueSnackbar('Update success', { variant: 'success' });
            history.push(
              recurringPatternData.is_food_run
                ? PATH_DASHBOARD.foodRun.myActiveRun
                : PATH_DASHBOARD.donations
            );
          })
          .catch((err) => {
            setLoading(false);
            enqueueSnackbar(err.message, { variant: 'error' });
          });
      } catch (err) {
        setLoading(false);
        enqueueSnackbar(err.message, { variant: 'error' });
      }
    },
  });

  const {
    handleSubmit,
    getFieldProps,
    touched,
    errors,
    setFieldValue,
    values,
  } = formik;

  useEffect(() => {
    if (values.startDate && values.startTime && values.endTime) {
      const startDate = moment(values.startDate)
        .hour(values.startTime.getHours())
        .minute(values.startTime.getMinutes())
        .second(values.startTime.getSeconds())
        .toISOString();
      let endDate = moment(values.endDate)
        .hour(values.endTime.getHours())
        .minute(values.endTime.getMinutes())
        .second(values.endTime.getSeconds())
        .toISOString();

      console.log(values.occurrenceType, startDate);
      if (values.occurrenceType === 'indefinite') {
        // A recurring food run or donation
        endDate = moment(startDate).add(90, 'days').toISOString();
      }

      checkAvailabilityForDrivers({
        pickupTime: startDate,
        endTime: endDate,
        occurrenceType: values.occurrenceType,
        interval: values.interval,
        daysOfTheWeek: processDaysOfTheWeek(values.daysOfTheWeek),
        dayOfTheMonth: values.dayOfTheMonth,
      });
    }
  }, [
    values.startDate,
    values.startTime,
    values.endDate,
    values.endTime,
    values.occurrenceType,
    values.interval,
    values.daysOfTheWeek,
    values.dayOfTheMonth,
  ]);

  const existingRecipientTeamIds = useMemo(
    () => [
      ...new Set(
        [
          recurringPatternData.receiver_team_id,
          ...patternPatialRescues.map((rescue) => rescue.recipient_team_id),
        ].filter(Boolean)
      ),
    ],
    [recurringPatternData.receiver_team_id, patternPatialRescues]
  );

  const {
    donors: _donors,
    recipients: _recipients,
    invalidate,
    recipientMatchesLoading,
  } = useEditRecurringDonations({
    user,
    recurringPatternData,
    pickupLocation: values.custom_addresses ? values.pickup_address : null,
    existingRecipientTeamIds,
    selectedDonor: getFieldProps('donor').value,
    ignoreDonorTeamId: recurringPatternData.donor_team_id,
    ignoreNpoTeamId: recurringPatternData.is_food_run
      ? recurringPatternData.receiver_team_id
      : null,
    isFoodRun: recurringPatternData?.is_food_run,
    recipientMatchRequest: buildFoodRunRecipientMatchRequest({
      donorTeamId: values.donor,
      pickupLocation: values.pickup_address,
      foodTypes: values.foodTypes,
      occurrenceType: values.occurrenceType,
      interval: values.interval,
      daysOfTheWeek: values.daysOfTheWeek,
      dayOfTheMonth: values.dayOfTheMonth,
      startDate: values.startDate,
      startTime: values.startTime,
      endTime: values.endTime,
    }),
  });

  useEffect(() => {
    setDonors(_donors);
    setRecipients(_recipients);
  }, [_donors, _recipients]);

  useEffect(() => {
    if (id && !recurringPatternData.id) {
      donations
        .getRecurringPatternById({
          id,
        })
        .then((data) => {
          setRecurringPatternData(data);
          const images = parseJsonArray(data?.images).map((url, i) => ({
            url,
            file: { id: uuidv4(), name: `Donation image #${i + 1}` },
          }));
          setImages(images);

          const additional = parseJsonArray(data.additional_images);
          setAdditionalImages(additional);
        })
        .catch(() => history.goBack())
        .finally(() => setFetchingPatternData(false));
    }
  }, [id, recurringPatternData]);

  const title = useMemo(
    () =>
      isFoodRun ? t('donations.food-run') : t('donations.recurring-donation'),
    [isFoodRun]
  );

  const closeInstancesWarning = () => setShowExistingInstanceWarning(false);

  const handleAddressChange = (name) => (val) => setFieldValue(name, val);

  const handleInventoryToggle = (item) => {
    const selectedInventoryItems = toggleInventoryItem(
      values.selectedInventoryItems,
      item,
      savedInventoryItems
    );
    const { foodTypes, appliedFoodTypes } = syncFoodTypesWithInventory({
      foodTypes: values.foodTypes,
      appliedFoodTypes: values.inventoryFoodTypes,
      savedFoodTypes: foodWeightObj,
      savedInventoryItems,
      selectedItems: selectedInventoryItems,
      isPartialRescue: values.isPartialRescue,
      weightUnit: defaultWeightUnit.value,
      validFoodTypes: foodTypeIds,
    });
    setFieldValue('selectedInventoryItems', selectedInventoryItems);
    setFieldValue('foodTypes', foodTypes);
    setFieldValue('inventoryFoodTypes', appliedFoodTypes);
  };

  const handleReceiverChange = (e) => {
    const receiverId = e.target.value;

    if ([null, undefined, '', 'unassigned'].includes(receiverId)) {
      setFieldValue('dest_address', {});
    } else {
      const selectedReceiver = recipients.find(
        (recipient) => recipient.team_id === receiverId
      );

      if (selectedReceiver) {
        setFieldValue('dest_address', {
          lat: selectedReceiver.lat,
          lng: selectedReceiver.lng,
          formattedAddress: selectedReceiver.formatted_address,
          place: selectedReceiver.place,
          name: selectedReceiver.place,
          streetAddress: selectedReceiver.street_address,
          city: selectedReceiver.city,
          province: selectedReceiver.province,
          country: selectedReceiver.country,
          zipCode: selectedReceiver.zip_code,
          placeId: selectedReceiver.place_id,
          timeZoneId: selectedReceiver.timezone_id,
        });
      }
    }

    getFieldProps('receiver').onChange(e);
  };

  return (
    <>
      <Button startIcon={<ChevronLeft />} onClick={() => history.goBack()}>
        {t('donations.back')}
      </Button>
      <Page title={`${t('donations.edit')} ${title}`}>
        {fetchingPatternData ? (
          <Box height="calc(100vh - 175px)">
            <LoadingScreen />
          </Box>
        ) : (
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Card>
                <CardContent>
                  <Typography variant="h5">
                    {t('donations.edit')} {title}
                  </Typography>
                  <Box height="25px" />
                  <TextField
                    fullWidth
                    label={t('donations.title')}
                    {...getFieldProps('title')}
                    error={Boolean(touched.title && errors.title)}
                    helperText={touched.title && errors.title}
                  />
                  <Box height="25px" />
                  <TextField
                    fullWidth
                    multiline
                    rows={5}
                    inputProps={{ maxLength: 1000 }}
                    helperText={`${
                      getFieldProps('description').value.length ?? 0
                    } / 1000`}
                    {...getFieldProps('description')}
                    label={t('donations.description')}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <Box height="25px" />
                  <EditDonationInventoryPicker
                    enabled={!isFoodRun}
                    selectedItems={values.selectedInventoryItems ?? []}
                    onToggle={handleInventoryToggle}
                  />
                  <DonationFoodTypesSelector
                    value={values.foodTypes}
                    onChange={(value) => setFieldValue('foodTypes', value)}
                    errors={parseErrorObject(errors)}
                    isPartialRescue={values.isPartialRescue}
                    deliveryOption={0}
                    onAddressChange={({ teamId, newAddress }) =>
                      handlePartialAddressChange({
                        teamId,
                        newAddress,
                        destinationAddresses: values.destinationAddresses,
                        setValue: setFieldValue,
                      })
                    }
                    destinationAddresses={values.destinationAddresses}
                    recipients={recipients}
                    setValue={setFieldValue}
                  />
                  <Box height="25px" />
                  <Grid container>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <RadioGroupComponent
                        label={t('donations.occurrence-type')}
                        {...getFieldProps('occurrenceType')}
                        value={
                          values.occurrenceType === 'onetime'
                            ? 'onetime'
                            : 'indefinite'
                        }
                        name="occurrenceType"
                        items={[
                          { label: t('donations.one-time'), value: 'onetime' },
                          {
                            label: t('donations.repeating'),
                            value: 'indefinite',
                          },
                        ]}
                        setFieldValue={(name, value) => {
                          if (
                            value === 'indefinite' &&
                            values.occurrenceType !== 'onetime'
                          )
                            return;
                          setFieldValue(name, value);
                          setFieldValue(
                            'endDate',
                            value === 'onetime' ? values.startDate : null
                          );
                        }}
                      />
                    </Grid>
                    {['recurring', 'indefinite'].includes(
                      getFieldProps('occurrenceType').value
                    ) ? (
                      <Grid
                        size={{ xs: 12, sm: 6 }}
                        className="flex-align-center"
                      >
                        <SelectComponent
                          label={t('donations.repeat-every')}
                          {...getFieldProps('interval')}
                          items={[
                            { value: 'Daily', title: t('donations.daily') },
                            { value: 'Weekly', title: t('donations.weekly') },
                            {
                              value: 'Bi-weekly',
                              title: t('donations.bi-weekly'),
                            },
                            { value: 'Monthly', title: t('donations.monthly') },
                          ]}
                          defaultValue="Daily"
                          onChange={(e) => {
                            const interval = e.target.value;
                            setFieldValue('interval', interval);

                            setFieldValue(
                              'endDate',
                              getScheduleEndDate({ ...values, interval })
                            );
                          }}
                        />
                      </Grid>
                    ) : null}
                  </Grid>

                  <Box>
                    {getFieldProps('interval').value === 'Weekly' ||
                    getFieldProps('interval').value === 'Bi-weekly' ? (
                      <Box>
                        <Box height="25px" />
                        <DaysOfTheWeeksSelector
                          {...getFieldProps('daysOfTheWeek')}
                          label={t('donations.repeat-on')}
                          setFieldValue={setFieldValue}
                          error={touched.daysOfTheWeek && errors.daysOfTheWeek}
                        />
                      </Box>
                    ) : null}
                    {getFieldProps('interval').value === 'Monthly' ? (
                      <Box>
                        <Box height="25px" />
                        <DayOfTheMonthSelector
                          value={getFieldProps('dayOfTheMonth').value}
                          onChange={(data) => {
                            setFieldValue('dayOfTheMonth', data);
                          }}
                          error={errors.dayOfTheMonth}
                        />
                      </Box>
                    ) : null}
                  </Box>
                  {values.occurrenceType !== 'onetime' && (
                    <DonationScheduleEnd
                      data={values}
                      onChange={({ occurrenceType, endDate }) => {
                        setFieldValue('occurrenceType', occurrenceType);
                        setFieldValue('endDate', endDate);
                      }}
                    />
                  )}
                  <Box>
                    <Box height="25px" />
                    <Box>
                      <Typography>
                        {t('donations.donation-available-date')}
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                          <DateComponent
                            name="startDate"
                            {...getFieldProps('startDate')}
                            onChange={(data) =>
                              setFieldValue('startDate', data)
                            }
                            customOnChange
                            label={t('donations.start-date')}
                          />
                        </Grid>
                        {getFieldProps('occurrenceType').value ===
                        'recurring' ? (
                          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <DateComponent
                              name="endDate"
                              {...getFieldProps('endDate')}
                              onChange={(data) =>
                                setFieldValue('endDate', data)
                              }
                              customOnChange
                              label={t('donations.end-date')}
                              minDate={getFieldProps('startDate').value}
                              error={errors.endDate}
                            />
                          </Grid>
                        ) : null}
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                          <TimeComponent
                            name="startTime"
                            {...getFieldProps('startTime')}
                            label={t('donations.start-time')}
                            onChange={(data) =>
                              setFieldValue('startTime', data)
                            }
                          />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                          <TimeComponent
                            name="endTime"
                            {...getFieldProps('endTime')}
                            label={t('donations.end-time')}
                            error={errors.endTime}
                            onChange={(data) => setFieldValue('endTime', data)}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  {!isFoodRun ? (
                    <>
                      <Box height="25px" />
                      <RadioGroupComponent
                        label={t('donations.delivery-option')}
                        {...getFieldProps('deliveryOption')}
                        name="deliveryOption"
                        items={[
                          { label: t('donations.self-deliver'), value: '0' },
                          {
                            label: t('donations.reciever-picks-up'),
                            value: '1',
                          },
                        ]}
                        setFieldValue={setFieldValue}
                        row
                        error={errors.deliveryOption}
                      />
                    </>
                  ) : null}
                  {recurringPatternData.is_food_run ? (
                    <>
                      <Box height="25px" />
                      <AutoCompleteComponent
                        label={t('donations.assign-donor')}
                        {...getFieldProps('donor')}
                        displayRefresh={true}
                        onRefresh={invalidate}
                        items={donors.map((donor) => ({
                          value: donor.team_id,
                          title: donor.name,
                          formatted_address: donor.formatted_address,
                          email: donor.email,
                        }))}
                        error={errors.donor}
                        helperText={errors.donor}
                      />{' '}
                    </>
                  ) : null}
                  {!recurringPatternData.is_partial ? (
                    <>
                      <Box height="25px" />
                      {recurringPatternData.is_food_run ? (
                        <AutoCompleteComponent
                          label={t('donations.assign-receiver')}
                          {...getFieldProps('receiver')}
                          onChange={handleReceiverChange}
                          displayRefresh={true}
                          onRefresh={invalidate}
                          loading={recipientMatchesLoading}
                          {...getFoodRunRecipientAutocompleteProps({
                            recipients,
                            value: values.receiver,
                            t,
                          })}
                          error={errors.receiver}
                        />
                      ) : (
                        <SelectComponent
                          label={t('donations.assign-receiver-optional')}
                          {...getFieldProps('receiver')}
                          onChange={handleReceiverChange}
                          displayRefresh={true}
                          onRefresh={invalidate}
                          items={[
                            {
                              value: 'unassigned',
                              title: t('donations.unassigned'),
                            },
                            ...recipients.map((recipient) => ({
                              value: recipient.team_id,
                              title: (
                                <>
                                  {recipient.animal_food_rescuer_type ? (
                                    <Pets fontSize="small" sx={{ mr: 1 }} />
                                  ) : null}
                                  {recipient.name} &nbsp;
                                  <Typography
                                    color="text.secondary"
                                    variant="overline"
                                  >
                                    {recipient.formatted_address}
                                  </Typography>
                                  <TaxExemptBadge
                                    org={recipient}
                                    sx={{ ml: 1 }}
                                  />
                                </>
                              ),
                            })),
                          ]}
                          error={errors.receiver}
                          helperText={errors.receiver}
                        />
                      )}
                    </>
                  ) : null}
                  {values.deliveryOption === '0' ? (
                    <>
                      <Box height="25px" />
                      <TextField
                        fullWidth
                        label={t('donations.delivery-radius', {
                          unit: distanceUnit.label,
                        })}
                        {...getFieldProps('deliveryRadius')}
                        error={Boolean(
                          touched.deliveryRadius && errors.deliveryRadius
                        )}
                        helperText={
                          touched.deliveryRadius && errors.deliveryRadius
                        }
                      />
                    </>
                  ) : null}

                  {isFoodRun ||
                  (!isFoodRun &&
                    getFieldProps('deliveryOption').value === '0' &&
                    (recurringPatternData.is_partial
                      ? true
                      : getFieldProps('receiver').value &&
                        getFieldProps('receiver').value !== 'unassigned')) ? (
                    <>
                      <Box height="25px" />
                      <DriverSelector
                        drivers={drivers}
                        vehicles={vehicles}
                        driversValue={values.drivers || []}
                        onChange={(drivers) =>
                          setFieldValue('drivers', drivers)
                        }
                        error={errors.drivers}
                      />
                    </>
                  ) : null}
                  {(isFoodRun ||
                    getFieldProps('deliveryOption').value === '0') &&
                  user.rescue_time_tracking_enabled &&
                  (plan === 'basic' || isFoodMover) ? (
                    <TextField
                      fullWidth
                      type="number"
                      margin="normal"
                      inputProps={{ min: 1, max: 720 }}
                      {...getFieldProps('estimatedRescueTimeMinutes')}
                      label={t('donations.estimated-rescue-time-minutes')}
                      error={Boolean(
                        touched.estimatedRescueTimeMinutes &&
                        errors.estimatedRescueTimeMinutes
                      )}
                      helperText={errors.estimatedRescueTimeMinutes}
                    />
                  ) : null}

                  <>
                    {isFoodRun ? (
                      <CheckboxFormComponent
                        label={t('donations.use-custom-address')}
                        {...getFieldProps('custom_addresses')}
                      />
                    ) : null}
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        mt: 0,
                        display: values['custom_addresses'] ? 'flex' : 'none',
                      }}
                    >
                      <Grid size={{ xs: 12, md: 6 }}>
                        <SelectAddressComponentPopup
                          {...getFieldProps('pickup_address')}
                          name="pickup_address"
                          label={
                            isFoodRun
                              ? t('donations.custom-pickup-address')
                              : t('donations.pickup-address')
                          }
                          onChange={handleAddressChange('pickup_address')}
                        />
                      </Grid>
                      {!recurringPatternData?.is_partial ? (
                        <Grid size={{ xs: 12, md: 6 }}>
                          <SelectAddressComponentPopup
                            {...getFieldProps('dest_address')}
                            name="dest_address"
                            label={
                              isFoodRun
                                ? t('donations.custom-destination-address')
                                : t('donations.destination-address')
                            }
                            onChange={handleAddressChange('dest_address')}
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </>

                  {((values.drivers || []).length > 0 ||
                    ![null, undefined, 'unassigned'].includes(values.driver)) &&
                  isFoodRun ? (
                    <CheckboxFormComponent
                      label={t('donations.make-available-on-unassign')}
                      {...getFieldProps('available_on_unassign')}
                    />
                  ) : null}

                  <Box height="25px" />
                  <RadioGroupComponent
                    label={t('donations.recommended-vehicle')}
                    {...getFieldProps('vehicleSize')}
                    name="vehicleSize"
                    items={vehicleLabelsWithUnit}
                    setFieldValue={setFieldValue}
                    row
                    error={errors.vehicleSize}
                  />
                  <>
                    {isFoodRun ||
                    getFieldProps('deliveryOption').value === '1' ? (
                      <>
                        <Box height="25px" />
                        <TextField
                          fullWidth
                          multiline
                          rows={5}
                          inputProps={{ maxLength: 1000 }}
                          helperText={`${
                            getFieldProps('pickupInstructions').value.length ??
                            0
                          } / 1000`}
                          {...getFieldProps('pickupInstructions')}
                          label={t('donations.pickup-instructions')}
                          error={Boolean(touched.name && errors.name)}
                        />
                      </>
                    ) : null}
                    {isFoodRun ||
                    getFieldProps('deliveryOption').value === '0' ? (
                      <>
                        <Box height="25px" />
                        <TextField
                          fullWidth
                          multiline
                          rows={5}
                          inputProps={{ maxLength: 1000 }}
                          helperText={`${
                            getFieldProps('dropoffInstructions').value.length ??
                            0
                          } / 1000`}
                          {...getFieldProps('dropoffInstructions')}
                          label={t('donations.dropoff-instructions')}
                          error={Boolean(touched.name && errors.name)}
                        />
                      </>
                    ) : null}
                  </>
                  <UploadImagesComponent
                    label={t('donations.donation-images')}
                    value={images}
                    onChange={setImages}
                    displayLabel={true}
                  />
                  <UploadImagesComponent
                    label={t('donations.additional-images')}
                    value={additionalImages}
                    onChange={setAdditionalImages}
                    displayLabel={true}
                  />
                  <Box height="25px" />
                  <Box textAlign="center" m={5}>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      size="large"
                      fullWidth
                      loading={loading}
                    >
                      {t('donations.update')} {title}
                    </LoadingButton>
                  </Box>
                </CardContent>
              </Card>
            </Form>
          </FormikProvider>
        )}
        <Dialog maxWidth="md" fullWidth open={showExistingInstanceWarning}>
          <>
            <Box
              marginBottom="15px"
              width="100%"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <DialogTitle>{t('donations.remove-existing-runs')}</DialogTitle>
            </Box>
            <DialogContent>
              <Typography>
                {t('donations.remove-existing-runs-description')}
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button onClick={closeInstancesWarning}>
                {t('donations.keep-claimed-runs')}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setDeleteExtraInstances(true);
                  closeInstancesWarning();
                }}
              >
                {t('donations.cancel-claimed-runs')}
              </Button>
            </DialogActions>
          </>
        </Dialog>
      </Page>
    </>
  );
};

export default EditRecurringPatternForm;

export const RadioGroupComponent = ({
  label,
  key,
  error,
  items,
  setFieldValue,
  name,
  ...params
}) => {
  const handleChange = (e) => {
    setFieldValue(name, e.target.value);
  };
  return (
    <FormControl margin="normal" error={!!error} key={key}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={label}
        name="radio-buttons-group"
        {...params}
        onChange={handleChange}
      >
        {items.map((item) => (
          <FormControlLabel
            value={item.value}
            key={item.value}
            control={<Radio />}
            label={item.label}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export const SelectComponent = ({
  items = [],
  displayRefresh = false,
  onRefresh = _noop,
  disabled = false,
  ...props
}) => {
  return (
    <Box
      width={'100%'}
      display="flex"
      alignItems="center"
      justifyContent={'center'}
    >
      <TextField
        {...props}
        select
        fullWidth
        defaultValue="Daily"
        disabled={disabled}
      >
        {items.map(({ value, title, disabled: itemDisabled }) => (
          <MenuItem key={value} value={value} disabled={itemDisabled}>
            {title}
          </MenuItem>
        ))}
      </TextField>
      {displayRefresh ? (
        <Button onClick={() => onRefresh?.()}>
          <Sync />
        </Button>
      ) : null}
    </Box>
  );
};

export function DaysOfTheWeeksSelector({
  key,
  error,
  label,
  setFieldValue,
  name,
  ...params
}) {
  const { t } = useTranslation('translation');
  return (
    <span key={key}>
      <Typography margin="5px" color={error ? 'error' : 'text.secondary'}>
        {label}
      </Typography>
      <ToggleButtonGroup
        aria-label={t('donations.days-of-the-week-selector')}
        color="primary"
        {...params}
        onChange={(e, value) => {
          setFieldValue(name, value);
        }}
      >
        <ToggleButton value="sunday" aria-label={t('donations.Sunday')}>
          {t('donations.day-0')}
        </ToggleButton>
        <ToggleButton value="monday" aria-label={t('donations.Monday')}>
          {t('donations.day-1')}
        </ToggleButton>
        <ToggleButton value="tuesday" aria-label={t('donations.Tuesday')}>
          {t('donations.day-2')}
        </ToggleButton>
        <ToggleButton value="wednesday" aria-label={t('donations.Wednesday')}>
          {t('donations.day-3')}
        </ToggleButton>
        <ToggleButton value="thursday" aria-label={t('donations.Thursday')}>
          {t('donations.day-4')}
        </ToggleButton>
        <ToggleButton value="friday" aria-label={t('donations.Friday')}>
          {t('donations.day-5')}
        </ToggleButton>
        <ToggleButton value="saturday" aria-label={t('donations.Saturday')}>
          {t('donations.day-6')}
        </ToggleButton>
      </ToggleButtonGroup>
      {error && (
        <Typography margin="5px" color="error" variant="body2">
          {error}
        </Typography>
      )}
    </span>
  );
}
